import { Stack, Button, Typography } from "@mui/material";
import { useCallback } from "react";
import {
  useAcceptInvitationMutation,
  useUpdateEncounterMutation,
} from "src/api/services/encountersApi";
import { Task } from "src/api/types";
import TaskWrapper from "src/wrappers/TaskWrapper";

interface Props {
  task: Task;
  onSuccess: () => void;
}

const SyncVisitRequestTask = ({ task, onSuccess }: Props) => {
  const [acceptInvitation, { isLoading, isError, data }] =
    useAcceptInvitationMutation();
  const [updateEncounter] = useUpdateEncounterMutation();

  const handleAccept = useCallback(() => {
    acceptInvitation({
      encounterId: task.resource_id,
    }).then(({ data }) => {
      if (data != null) {
        window.open(data?.room_url, "_blank");
      }
    });
  }, [acceptInvitation, task.resource_id]);

  const handleComplete = useCallback(() => {
    updateEncounter({
      encounterId: task.resource_id,
      status: "completed",
    }).then(onSuccess);
  }, [onSuccess, task.resource_id, updateEncounter]);

  return (
    <TaskWrapper task={task}>
      {isError === true ? (
        <Typography color="error" textAlign="center">
          Could not accept invitation
        </Typography>
      ) : null}

      <Stack direction="row" gap={1} justifyContent="center">
        {data != null ? (
          <Button onClick={handleComplete}>Complete</Button>
        ) : (
          <Button onClick={handleAccept} loading={isLoading}>
            Accept
          </Button>
        )}
        {/* <Button onClick={handleDeny} variant="secondary" loading={isLoading}>
                Deny
              </Button> */}
      </Stack>
    </TaskWrapper>
  );
};

export default SyncVisitRequestTask;
